import { createReducer, on } from '@ngrx/store';
import * as PacksActions from '../actions/packs.actions';

export interface State {
  packs: any[];
  errorMessage: string | null;
  isLoading: boolean;
}
export const initialState: State = {
  packs: [],
  errorMessage: null,
  isLoading: false
};
export const packsReducer = createReducer(
  initialState,

  on(PacksActions.loadPacks, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(PacksActions.loadPacksSuccess, (state, { packs }) => ({
    ...state,
    packs: packs,
    isLoading: false,
    errorMessage: null
  })),

  on(PacksActions.loadPacksFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  }))
);